import React from "react"
import { motion } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { springVariants, rightVariants, leftVariants, springViewport } from '../utils/framerVariants'

const StickyMedia = ({ data }) => {

  const isOpposite = data.Direction && data.Direction.startsWith("Opposite")
  const isPortrait = data.portraitMode === true;
  let containerClass, imageClass, captionClassLeft, captionClassRight, captionClassRichTextLeft, captionClassRichTextRight;

  if (isPortrait) {
    imageClass = "aspect-DINA2 md:max-w-sm xl:max-w-md";
    captionClassLeft = "text-left pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 md:max-w-sm xl:max-w-md"
    captionClassRight = "text-left pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 md:max-w-sm xl:max-w-md"
    captionClassRichTextLeft = "caption-rich-text-left md:max-w-sm xl:max-w-md text-left"
    captionClassRichTextRight = "caption-rich-text-right text-right "
  } else {
    imageClass = "aspect-3/2";
    captionClassLeft = "text-left pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50"
    captionClassRight = "text-right pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50"
    captionClassRichTextLeft = "caption-rich-text-left text-left"
    captionClassRichTextRight = "caption-rich-text-right text-left sm:float-right"
  }

  const renderCaptionLeft = () => {
    if (data.captionText?.trim()) {
      return <div className={captionClassRichTextLeft} dangerouslySetInnerHTML={{ __html: data.captionText }} />;
    } else if (data.Media.caption) {
      return <p className={captionClassLeft}>{data.Media.caption}</p>;
    }
    return null;
  };

  const renderCaptionRight = () => {
    if (data.captionText?.trim()) {
      return <div className={captionClassRichTextRight} dangerouslySetInnerHTML={{ __html: data.captionText }} />;
    } else if (data.Media.caption) {
      return <p className={captionClassRight}>{data.Media.caption}</p>;
    }
    return null;
  };


  return (
    <>
      {isOpposite ? (
        <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-0 md:pb-24 lg:pb-32 xl:pb-48 mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-0 sm:px-8 md:px-24 lg:px-24 xl:px-24">
          <div className="flex flex-col sm:flex-row">
            <div className="sm:basis-7/12 basis-full">
              <div className="sm:sticky sm:top-32 lg:top-48 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
                {data.Media && <motion.div
                  variants={springVariants}
                  initial="invisible"
                  whileInView="visible"
                  viewport={springViewport}
                  className="pr-0 sm:pr-12 md:pr-16 lg:pr-32 mb-8 sm:mb-0 sm:mt-2"
                  >
                  <GatsbyImage
                    className={imageClass}
                    image={getImage(data.Media.file)}
                    alt={data.Media.alternativeText || "Alternative Text missing"}
                  />
                  {renderCaptionLeft()}
                </motion.div>
                }
              </div>
            </div>
            <div className="sm:basis-5/12 basis-full pr-4 sm:pr-0 pl-4 lg:pl-12 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
                {data.Headline &&
                  <motion.h2 variants={springVariants} initial="invisible" whileInView="visible" viewport={springViewport} className="text-headline-md tracking-headline-md leading-headline-md font-bold mb-8">
                    {data.Headline}
                  </motion.h2>
                }
                {data.Text && <motion.div
                  variants={springVariants}
                  initial="invisible"
                  whileInView="visible"
                  viewport={springViewport}
                  className="richtext sticky-text"
                  dangerouslySetInnerHTML={{__html: data.Text}} />
                }
            </div>
          </div>
        </article>
      ) : (
        <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-0 md:pb-24 lg:pb-32 xl:pb-48 mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-0 sm:px-8 md:px-24 lg:px-24 xl:px-24">
          <div className="flex sm:flex-row flex-col-reverse">
            <div className="sm:basis-5/12 basis-full pl-4 sm:pl-0 pr-4 lg:pr-12 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
              {data.Headline &&
                <motion.h2 variants={springVariants} initial="invisible" whileInView="visible" viewport={springViewport} className="text-headline-md tracking-headline-md leading-headline-md font-bold mb-8">
                  {data.Headline}
                </motion.h2>
              }
              {data.Text && <motion.div
                variants={springVariants}
                initial="invisible"
                whileInView="visible"
                viewport={springViewport}
                className="richtext sticky-text"
                dangerouslySetInnerHTML={{__html: data.Text}} />
              }
            </div>
            <div className="sm:basis-7/12">
              <div className="sm:sticky sm:top-32 lg:top-48 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48 pb-8 sm:pb-0">
                {data.Media && <motion.div
                  variants={springVariants}
                  initial="invisible"
                  whileInView="visible"
                  viewport={springViewport}
                  className="pl-0 sm:pl-12 md:pl-16 lg:pl-32 mt-2 text-right"
                  >
                  <GatsbyImage
                  className={imageClass}
                    image={getImage(data.Media.file)}
                    alt={data.Media.alternativeText || "Alternative Text missing"}
                  />
                  {renderCaptionRight()}
                </motion.div>
                }
              </div>
            </div>
          </div>
        </article>
      )}
    </>
  )
}

export default StickyMedia
